/**
 * The caveat dot — first-class, per `docs/DESIGN-SYSTEM.md`.
 *
 * It exists because this project has a rule ("state caveats plainly") that
 * needs somewhere to live or it gets dropped. On this page the load-bearing
 * case is **Viewers**: the spec calls it a headline column, and it is
 * channel-wide uniques deduplicated across content types — 49% above
 * `STORY_UNIQUES` on Tiny Texts. A reader who assumes it means *story* viewers
 * is wrong, and nothing on screen would tell them.
 *
 * It shows through `Hint` rather than the native `title`: the browser holds a
 * `title` for about a second before showing it, which on a table full of
 * caveated columns reads as the caveat being unavailable. `aria-label` still
 * carries the text, so a screen reader is unaffected.
 */
import { Hint } from './Hint'

export function InfoDot({ note }: { note: string }) {
  return (
    <Hint
      label={note}
      className="ml-1 inline-flex items-center justify-center align-middle text-[0.6rem] font-bold"
      style={{
        width: '0.95rem',
        height: '0.95rem',
        borderRadius: '999px',
        background: 'var(--brand-tint)',
        color: 'var(--brand-ink)',
        cursor: 'help',
      }}
    >
      <span role="note" aria-label={note}>
        i
      </span>
    </Hint>
  )
}
